import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
//Import Mixpanel SDK
import mixpanel from "mixpanel-browser";
// Near entry of your product, init Mixpanel
mixpanel.init("a3bf9a4912ae803ee2d853216945e8c7", {
  debug: true,
  track_pageview: true,
  persistence: "localStorage",
});
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
